import React from 'react'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { SectionId } from './constants'
import styles from './VdcEducationPage.module.scss'

interface SectionContainerProps {
  id: SectionId
  title: string
  sectionRef: (el: HTMLDivElement | null) => void
  children: React.ReactNode
}

const SectionContainer: React.FC<SectionContainerProps> = ({ id, title, sectionRef, children }) => (
  <Container
    ref={sectionRef}
    data-section-id={id}
    className={`${styles.section} ${styles[`section--${id}`]} flex flex-column`}
  >
    <Typography variant="HM2" className={styles['section__title']}>{title}</Typography>
    {children}
  </Container>
)

export default SectionContainer

